import axios from 'axios';
import router from '@/services/router.js';

// !!convierte en booleano
function initialState() {
    return {
        user: (window.localStorage.getItem('user')) ? JSON.parse(window.localStorage.getItem('user')) : null,
        datos: {
            id: '',
            remember_token: '',
            nombre: '',
            direccion: '',
            email: '',
            celular: '',
            barrio_id: null,
        },
        token: (window.localStorage.getItem('token')) ? window.localStorage.getItem('token') : null,
        expires_in: (window.localStorage.getItem('expires_in')) ? window.localStorage.getItem('expires_in') : null,
        logged: !!window.localStorage.getItem('token'),
        loading: false,
        users_permisos_modulos: {}
    }
}

export const state = initialState()

export const actions = {
    login({ commit }, userInput) {
        return new Promise((resolve, reject) => {
            console.log('************ LOGIN')
            axios.post('login', userInput)
                .then( user => {
                    if (user.data.access_token) {
                        window.localStorage.setItem('token', user.data.access_token);
                        window.localStorage.setItem('user', JSON.stringify(user.data.user));
                        window.localStorage.setItem('expires_in', user.data.expires_in);
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.data.access_token;
                        commit('setUser');
                        router.push('/');
                    }
                    resolve(user);

                })
        })
    },
    register({ commit }, userInput) {
        return new Promise((resolve, reject) => {
            console.log('************ REGISTRAR')
            axios.post('signup', userInput)
                .then(response => {
                    if (response.data.access_token) {
                        window.localStorage.setItem('expires_in', response.data.expires_in);
                        window.localStorage.setItem('token', response.data.access_token);
                        window.localStorage.setItem('user', JSON.stringify(response.data.user));
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token;
                        commit('setUser');
                        router.push('/');
                    }
                    resolve(response);
                })
        })
    },
    updatePasswordToken({ commit }, userInput) {
        return new Promise((resolve, reject) => {
            console.log('************ CAMBIAR CONTRASEÑA TOKEN')
            axios.put('cambiar-password-token', userInput)
                .then(response => {
                    resolve(response);
                })
        })
    },
    verifyLogin({ commit }, userInput) {
        return new Promise((resolve, reject) => {
            console.log('************ VERIFICAR LOGIN')
            axios.post('auth/me', userInput)
                .then(response => {
                    if (response.data.success) {
                        commit('verifyLogin');
                    }
                    resolve(response);
                })
        })
    },
    verifyTokenChangePassword({ commit }, userInput){
        return new Promise((resolve, reject) => {
            console.log('************ VERIFY TOKEN CHANGE PASSWORD')
            axios.post('verify-token-change-password', { token: userInput })
                .then(response => {
                    console.log(response)
                        // window.localStorage.setItem('token', user.body.token);
                        // commit(types.mutations.setUser);
                    resolve(response);
                })
        })
    },
   solicitarChangePassword ({ commit }, userInput) {
        return new Promise((resolve, reject) => {
            console.log('************ SOLICITAR CHANGE PASSWORD')
            axios.post('solicitar-change-password', { email: userInput })
                .then(response => {
                    console.log(response)
                        // window.localStorage.setItem('token', user.body.token);
                        // commit(types.mutations.setUser);
                    resolve(response);
                })
        })
    },
    logout({ commit, dispatch }){
        console.log('************ LOGOUT')
        if (window.localStorage.getItem('token')) {
            axios.post('logout')
        }
        window.localStorage.clear();
        commit('resetState');
        delete axios.defaults.headers.common["Authorization"];
        router.push('/auth/login');
    },
};

export const getters = {
    //Obtenemos el usuario
    user(state) {
        return state.user;
    },
    //Está logueado?
    logged(state) {
        return state.logged;
    },
};

export const mutations = {
    resetState(state) {
        Object.assign(state, initialState())
    },
    //Establecemos el user a través del token jwt
    setUser(state){
        if (window.localStorage.getItem('token') && window.localStorage.getItem('user')) {
            state.token = window.localStorage.getItem('token');
            state.user = JSON.parse(window.localStorage.getItem('user'));
            state.logged = true;
            state.datos = {
                id: '',
                remember_token: '',
                nombre: '',
                direccion: '',
                email: '',
                celular: '',
                barrio_id: null,
            };
        } else {
            state.token = null;
            state.user = null;
            state.logged = false;
            state.datos = {
                id: '',
                remember_token: '',
                nombre: '',
                direccion: '',
                email: '',
                celular: '',
                barrio_id: null,
            };
        }
    },
    verifyLogin(state, logged) {
        // state.logged = logged;
    },
    //Establecemos el estado del usuario
    setLogged(state, logged) {
        state.logged = logged;
    },
    //Establecemos el estado del usuario
};